import { FeatureTreeActionType } from './action-types';
import type {
    IFeatureTree,
    IRequestFeatureTreeAction,
    IReceiveFeatureTreeAction,
    IFeatureTreeErrorAction,
} from './action-types';

export function requestFeatureTree(groups: string[]): IRequestFeatureTreeAction {
    return { type: FeatureTreeActionType.REQUEST_FEATURE_TREE, payload: { groups } };
}

export function receiveFeatureTree(tree: IFeatureTree): IReceiveFeatureTreeAction {
    return { type: FeatureTreeActionType.RECEIVE_FEATURE_TREE, tree };
}

export function featureTreeError(
    errorMessage?: string,
    statusCode?: number | null,
    isGeoBlocked?: boolean,
    isAccessDenied?: boolean
): IFeatureTreeErrorAction {
    return { type: FeatureTreeActionType.ERROR_FEATURE_TREE, errorMessage, statusCode, isGeoBlocked, isAccessDenied };
}
